import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Zimmerservice',
      [RoomServiceLocationType.TableService]: 'Tischservice',
    },
    [ORDER_METHODS.PICKUP]: 'Abholung',
    [ORDER_METHODS.DELIVERY]: 'Lieferung',
  },
  errors: {
    draft_validation_failed: 'Bitte vervollständige deine Lieferadresse, bevor du fortfährst.',
  },
};
